import Events from "../utils/Events.js";
import NuCalBaseView from "./NuCalBaseView.js";

/**
 * @extends NuCalBaseView
 * @param {String} props.namespace The namespace in which this object should subscribe and publish events on.
 * @param {HTMLElement} props.view The HTML Element in which this object should render the output too.
 * @param {String} props.dateType Which date the object is dealing with. Can be "arrival", "departure" or "both". Default is "both".
 * @param {String} props.locale Language code. Default "en-US."
 * @param {String} props.UUID Unique Identifier. the default is randomly generated.
 * @param {Object} props.lexicon JSON object containing langauge strings.
 * @param {String} props.lexicon.arrivalString what is announced when the arrival date is updated. Default "the arrival date is [date]."
 * @param {String} props.lexicon.departureString what is announced when the departure date is updated. Default "the departure date is [date]."
 */
class NuCalAnnouncerView extends NuCalBaseView {

	constructor(props){
		props.view = props.view || document.getElementById("nuCalAnnouncer");
		if(props.view === null){
			props.view = document.createElement("div");
			props.view.id = "nuCalAnnouncer";
			props.view.setAttribute("aria-live","assertive");
			props.view.setAttribute("role","alert");
			document.body.appendChild(props.view);
		}
		super(props);
	}

	subscribe(){
		this._subscriptions.push(Events.subscribe(this._events.datesUpdated,this.render.bind(this)));
	}

	render(props){
		this.view.innerHTML = "";
        
		const arrivalString = this.lexicon.NuCalAnnouncerView.arrivalText.replace("[date]",props.arrivalDate.toLocaleDateString({weekday: "long", year: "numeric", month: "long", day: "numeric"}));
        
		const departureString = this.lexicon.NuCalAnnouncerView.departureText.replace("[date]",props.departureDate.toLocaleDateString({weekday: "long", year: "numeric", month: "long", day: "numeric"}));

		this.view.innerHTML = `${arrivalString} ${departureString}`;

	}

}

export default NuCalAnnouncerView;